<div class="timeline-wrapper">
	<ng-content></ng-content>
	<div *ngIf="timelineExists" class="timeline" [style.top]="getTimelineFromTop() + '%'">
	</div>
</div>